<div class="dls-page-section">

  <dls-right-side-nav *ngIf="title" [id]="sectionFragmentID" [title]="title" [level]="2" [offset]="-20">
  </dls-right-side-nav>

  <!-- Section subheading -->
  <h2 #titleReference class="section-heading" *ngIf="title" (mouseenter)="isMouseOver = true"
    (mouseleave)="isMouseOver = false">
    {{title}}
    <button atlas-icon-button (click)="copyLink()" aria-label="Share Link" class="ms-1">
      <mat-icon [ngClass]="{'visible': isMouseOver || isFocus, 'invisible': !isMouseOver && !isFocus}">link</mat-icon>
    </button>
  </h2>

  <!-- Aside and Section -->
  <div class="row" [ngStyle]="{'margin-bottom': sectionSpacer + 'px'}">
    <div #asideContent [ngClass]="{'col-12 mb-3': asideContent.children.length}">
      <ng-content select="aside"></ng-content>
    </div>
    <div class="col-12">
      <ng-content select="section"></ng-content>
    </div>
  </div>
</div>